import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Box from '../box/box.jsx';
import styles from './connection-modal.css';

const ConnectingStep = props => (
    <Box className={styles.body}>
        <Box className={styles.activityArea}>
            <div className={styles.centeredRow}>
                <div className={styles.peripheralActivity}>
                    <img
                        className={classNames(styles.radarSmall, styles.radarSpin)}
                        src="/static/assets/c25c9919121ad3094ae6d673228866d0.svg"
                    />
                    <img
                        className={styles.bluetoothConnectingIcon}
                        src="/static/assets/bf93df4077d061286256d2994417db42.svg"
                    />
                </div>
            </div>
            <div className={styles.instructions}>
                <p>Bağlanılıyor...</p>
                {props.peripheralName && (
                    <p>{props.peripheralName}</p>
                )}
            </div>
        </Box>
        <Box className={styles.bottomArea}>
            <div className={classNames(styles.bottomAreaItem)}>
                <button
                    className={classNames(styles.connectionButton)}
                    onClick={props.onCancel}
                >
                    İptal
                </button>
            </div>
        </Box>
    </Box>
);

ConnectingStep.propTypes = {
    onCancel: PropTypes.func.isRequired,
    peripheralName: PropTypes.string
};

export default ConnectingStep;
